import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";

const toSlug = (v) => "/marabout-" + v.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/^L'/, "").toLowerCase().replace(/ /g, "-");

const main = [
  { name: "Saint-Denis", desc: "Nord · Chef-lieu" },
  { name: "Saint-Paul", desc: "Ouest" },
  { name: "Saint-Pierre", desc: "Sud" },
  { name: "Le Tampon", desc: "Hauts du Sud" },
  { name: "Saint-André", desc: "Est" },
  { name: "Saint-Louis", desc: "Sud-Ouest" },
];

const others = [
  "Saint-Benoît", "Saint-Joseph", "Le Port", "Saint-Leu", "Sainte-Marie", "La Possession", "Sainte-Suzanne",
  "L'Étang-Salé", "Petite-Île", "Bras-Panon", "Les Avirons", "Trois-Bassins", "Salazie", "Entre-Deux",
  "Cilaos", "Sainte-Rose", "Saint-Philippe",
];

const SEOVillesReunion = () => (
  <section id="villes" className="py-24 md:py-32 bg-[#09090b]" data-testid="villes-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionTitle eyebrow="Villes de La Réunion" title="Marabout dans" gold="toute l'île"
        subtitle="Maître Diamma accompagne les habitants des 24 communes de La Réunion, en consultation ou à distance." />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-10" data-testid="villes-reunion-grid">
        {main.map((v, i) => (
          <Reveal key={v.name} delay={i * 70}>
            <Link to={toSlug(v.name)} data-testid={`ville-link-${i}`} className="lux-card block p-5 text-center h-full">
              <MapPin className="w-5 h-5 text-amber-400 mx-auto mb-2" strokeWidth={1.5} />
              <h3 className="font-heading text-sm text-white">Marabout {v.name}</h3>
              <p className="text-zinc-500 text-xs mt-1">{v.desc}</p>
            </Link>
          </Reveal>
        ))}
      </div>
      <Reveal>
        <div className="rounded-2xl border border-amber-500/10 bg-zinc-950/60 p-6 md:p-8">
          <p className="text-center text-amber-300/90 text-sm tracking-wide mb-5">Également disponible dans toutes les communes du 974</p>
          <div className="flex flex-wrap justify-center gap-2">
            {others.map((v, i) => (
              <Link key={v} to={toSlug(v)} data-testid={`ville-secondaire-link-${i}`}
                className="px-3 py-1.5 rounded-full text-xs sm:text-sm border border-zinc-800 text-zinc-300 hover:text-amber-300 hover:border-amber-500/40 transition-colors duration-300">
                Marabout {v}
              </Link>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default SEOVillesReunion;
